var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"js-main"},[_c('self-header'),_c('div',{staticClass:"js-middle"},[_c('self-menu',{}),_c('div',{staticClass:"content-box"},[_c('router-view',{})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }